/* src/app/accounts/pricing/pricing.component.scss */
header.allfeatureHeader {
  background-color: #04363d;
  padding-top: 100px;
  padding-bottom: 100px;
  margin-top: -10px;
  margin-left: -31px;
  margin-right: -30px;
  height: 280px;
  background-image: url("./media/search-candidate-bg-MYLCRRFL.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left top;
}
.monthlyYearlyBtn {
  color: #206c79;
  background-color: #ffffff;
  border-radius: 2px;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 0 4px 0 rgba(197, 197, 197, 0.5);
  width: 245px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.monthlyYearlyBtn.active {
  background-color: #c4edf4;
  border-radius: 0px;
  border: 1px solid #206c79;
  color: #206c79;
  padding: 11px 26px;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 0 4px 0 rgba(197, 197, 197, 0.5);
  border: 1px solid #2e93a1;
}
.pricing-table-bg-gradient {
  height: 660px;
  background-image:
    linear-gradient(
      to bottom,
      #ffffff,
      #2e93a1);
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  opacity: 0.11;
  top: -70px;
  z-index: -1;
  left: -31px;
  margin-right: -60px;
}
.pricing-table-bg-gradient2 {
  height: 400px;
  background-image: linear-gradient(#ffffff, #2E93A1);
  border-bottom-left-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  opacity: 0.11;
  top: 0px;
  z-index: -1;
  opacity: 0.11;
  background-image:
    linear-gradient(
      to bottom,
      #ffffff,
      #2e93a1);
  transform: rotate(180deg);
  left: -31px;
  margin-right: -60px;
}
.price-text-color {
  color: #AF2C2C;
}
.select-plan-btn,
.contact-sales-btn {
  width: 220px;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #fff;
  border-radius: 2px;
  background-color: #2E93A1;
  border: none;
  display: block;
}
.contact-sales-btn {
  background-color: #2E93A1;
  color: #ffffff;
  border: 1px solid #2E93A1;
}
.text-blue-green {
  color: #2E93A1;
}
.feature-section {
  margin-top: 170px;
}
.feature-header-margin-top {
  margin-top: -140px;
}
.top-640 {
  top: -640px;
}
.tabBTnContainer {
  padding-top: 35px;
  padding-bottom: 100px;
}
@media only screen and (max-width: 600px) {
  .feature-header-margin-top {
    margin-top: 0px;
  }
  .pricing-table-bg-gradient {
    height: 100%;
  }
  .top-640 {
    top: 0px;
  }
  .feature-section {
    height: 100%;
    margin-top: 0;
  }
  .tabBTnContainer {
    padding-top: 15px;
    padding-bottom: 35px;
  }
}
.f-36 {
  font-size: 36px;
}
.f-40 {
  font-size: 40px;
}
.top-center {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.cross-icon {
  transform: rotate(45deg);
  font-size: 20px;
}
.ultimate-card {
  border: solid 1px #2e93a1;
}
.label-container {
  position: absolute;
  top: 0;
  right: 0;
}
.corner {
  width: 0;
  height: 0;
  border-right: 80px solid #ffcc00;
  border-bottom: 80px solid transparent;
  border-left: 0px solid transparent;
}
.corner span {
  position: absolute;
  top: 10px;
  width: 75px;
  right: -12px;
  text-align: center;
  font-size: 12px;
  font-family: arial;
  transform: rotate(45deg);
  display: block;
  font-weight: 600;
  color: #cd9600;
}
.top-corner-box {
  width: 20px;
  height: 20px;
  border-top-right-radius: 4px;
  border-top: solid 1px #2e93a1;
  border-right: solid 1px #2e93a1;
  position: absolute;
  right: -1px;
  top: -1px;
}
.monthfree {
  padding: 2px 5px 2px;
  border-radius: 3px;
  background-color: #ffd200;
  color: #cd9600;
  font-size: 12px;
  font-weight: 600;
}
.wctooltip {
  position: relative;
  display: inline-block;
}
.wctooltip .tooltiptext {
  visibility: hidden;
  width: 260px;
  background-color: black;
  color: #fff;
  border-radius: 2px;
  padding: 12px;
  position: absolute;
  z-index: 2;
  bottom: 100%;
  left: 35px;
  margin-left: 0px;
  opacity: 0;
  white-space: normal;
  transition: opacity 1s;
}
.wctooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.price-card {
  width: 100%;
  height: 686px;
  padding: 40px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
.price-card.ultimate-card {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
  z-index: 1;
}
.select-plan-btn {
  padding: 10px 57px 10px 58px;
  border-radius: 2px;
  border: solid 1px #2E93A1;
  background-color: #ffffff;
  color: #2E93A1;
}
.select-plan-btn:hover {
  padding: 10px 57px 10px 58px;
  border-radius: 2px;
  border: solid 1px #2E93A1;
  background-color: #2E93A1;
  color: #fff !important;
}
.price-card.ultimate-card .select-plan-btn {
  padding: 10px 10px 10px 10px;
  border-radius: 2px;
  border: solid 1px #2E93A1;
  background-color: #2E93A1;
  color: #fff !important;
}
.price-card.ultimate-card .select-plan-btn {
  padding: 10px 10px 10px 10px;
  border-radius: 2px;
  border: solid 1px #2E93A1;
  background-color: #2E93A1;
  color: #fff !important;
}
.spacer {
  height: 70px;
}
.container {
  width: 1240px;
}
.text-9696 {
  color: #969696;
}
.f-36 {
  font-size: 36px;
}
.f-40 {
  font-size: 40px;
}
.text-ffd {
  color: #ffd200;
}
.bg-yellow {
  background-color: #FFF3BA !important;
  border: 1px solid #FFE053 !important;
}
.plans-div {
  height: 200px;
  width: 200px;
  border: 1px solid #CBCBCB;
  padding-top: 22px;
}
.star-div {
  background-color: rgb(233, 79, 88);
  color: white;
  border-radius: 10px;
  padding: 6px;
  font-size: 12px;
}
.text-underline {
  color: #2E93A1;
  text-decoration: underline;
}
.p-none {
  pointer-events: none !important;
  cursor: none !important;
}
/*# sourceMappingURL=pricing.component-AJF6JAEJ.css.map */
